// extracted by mini-css-extract-plugin
module.exports = {"loading":"SageShimmerListItem_loading__2b-Cn","container":"SageShimmerListItem_container__3tYUk"};